import type { TimeStreamAssets } from 'owa-timestream-types';

export default function markAllAssetsAsDeleted(assets: TimeStreamAssets) {
    for (const asset of assets.values()) {
        asset.deleted = true;
    }
}
